import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { createManualStockMovement, fetchManualStockMovements } from "./thunks";
import { ProductStock, StockStats } from "@/types";
import { toast } from "react-toastify";

interface PaginatedStocks {
  data: ProductStock[];
  total?: number;
  currentPage?: number;
  perPage?: number;
}

interface StocksState {
  movements: PaginatedStocks;
  stats: StockStats | null;
  loading: boolean;
  error: string | null;
}

const initialState: StocksState = {
  loading: false,
  error: null,
  movements: { data: [] },
  stats: null,
};

const stockSlice = createSlice({
  name: "stock",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchManualStockMovements.pending, (state, action) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(
        fetchManualStockMovements.fulfilled,
        (
          state,
          action: PayloadAction<{
            manualStockMovement: any;
            stats: StockStats;
          }>,
        ) => {
          state.loading = false;

          const { manualStockMovement, stats } = action.payload;

          if (manualStockMovement && Array.isArray(manualStockMovement.data)) {
            // Dados paginados
            state.movements = {
              data: manualStockMovement.data,
              total: manualStockMovement.total,
              currentPage: manualStockMovement.current_page,
              perPage: manualStockMovement.per_page,
            };
          } else if (Array.isArray(manualStockMovement)) {
            state.movements = { data: manualStockMovement };
          } else {
            state.movements = { data: [] };
          }

          state.stats = stats;
        },
      )
      .addCase(fetchManualStockMovements.rejected, (state, action) => {
        state.error = (action.payload as { error: string }).error;
        state.loading = false;
      })

      .addCase(createManualStockMovement.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(
        createManualStockMovement.fulfilled,
        (state, action: PayloadAction<any>) => {
          state.loading = false;
          state.movements.data.push(action.payload.data);

          const type =
            action.payload.data.type === "entry" ? "Entrada" : "Saída";
          toast.success(`${type} de produto cadastrada com sucesso!`);
        },
      )
      .addCase(createManualStockMovement.rejected, (state, action) => {
        state.error = (action.payload as { error: string }).error;
        state.loading = false;
        toast.error(
          "Não foi possível cadastrar a movimentação, tente novamente!",
        );
      });
  },
});

export default stockSlice.reducer;
